module.exports = __webpack_public_path__ + "static/media/buy_pause_payment_4.92ca70ee.jpg";